import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';
import { debug } from 'util';

/*
 * <pre>
 * <b>Class name: AuthGuard</b>
 * <b>Explanation:</b> Service AuthGuard
 * <b>Creation date:</b> 2019/08/25
 * </pre>
 *
 * @author GCS 2019/08/25 by linhdh
 **/
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    permissions: any;
    userType: any;
    isParent: any;
    ENTERPRISE_LOGIN = '/enterprise-login';
    // currentModule = '';
    // currentScreen: any;
    // currentfunction = '';

    /**
     * <pre>
     * <b>Method name: constructor</b>
     * <b>Explanation: </b> Method constructor
     * </pre>
     * @author GCS 2019/08/25 by linhdh
     *
     */
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private toastr: ToastrService
    ) { }

    /**
     * <pre>
     * <b>Method name: canActivate</b>
     * <b>Explanation: </b> Method setting can activate routing
     * </pre>
     * @author GCS 2019/08/25 by linhdh
     *
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const accessRight = route.data.accessRight;
        const defaultPath = route.data.defaultPath;

        if (sessionStorage.getItem('selectModeYet')) {
            if (state.url.indexOf('/enterprise-login') >= 0) {
                return true;
            } else {
                this.router.navigate([this.ENTERPRISE_LOGIN]);
                return false;
            }
        }

        if (!localStorage.getItem('userId') || (!localStorage.getItem('token') && !sessionStorage.getItem('token'))) {
            if (state.url.indexOf('/enterprise-login') >= 0 || state.url.indexOf('/download-app') >= 0) {
                return true;
            }

            this.router.navigate([this.ENTERPRISE_LOGIN]);
            return false;
        }

        if (state.url.indexOf('/enterprise-login') >= 0) {
            // this.router.navigate(['/home-enterprise/main']);
            this.router.navigate(['/home-enterprise/analysis-report']);
            return false;
        }

        // if (state.url.indexOf('/home-enterprise/main') >= 0) {
        if (state.url.indexOf('/home-enterprise/analysis-report') >= 0) {
            return true;
        }

        return this.authenticationService.getPermissionInfo()
            .pipe(map(rs => {
                try {
                    if (rs && rs.data) {
                        if (rs.data.permissions === null) {
                            this.authenticationService.logout();
                            this.router.navigate([this.ENTERPRISE_LOGIN]);
                            return false;
                        }
                        this.userType = rs.data.userType;
                        this.permissions = rs.data.permissions;
                        this.isParent = rs.data.isParent;

                        if (!accessRight) {
                            return true;
                        } else {
                            const allowedUser = accessRight.find(x => x.userType == this.userType);
                            if (allowedUser && ((allowedUser.userType > 0 && allowedUser.permissons.some(x => this.permissions.indexOf(x) >= 0)) || allowedUser.userType === 0)) {
                                if (allowedUser.checkParent && !this.isParent) {
                                    this.router.navigate([defaultPath]);
                                } else {
                                    return true;
                                }
                            } else {
                                this.authenticationService.logout();
                                this.router.navigate([defaultPath]);
                                return false;
                            }
                        }

                        return true;
                    } else {
                        this.authenticationService.logout();
                        this.router.navigate([this.ENTERPRISE_LOGIN]);
                        return false;
                    }
                } catch (e) {
                    this.authenticationService.logout();
                    this.router.navigate([this.ENTERPRISE_LOGIN]);
                    return false;
                }
            }));
    }
}
